import React, { useContext, useState } from "react";
import { Button, Table, Tooltip } from "antd";
import { AuditOutlined, AlertOutlined } from "@ant-design/icons";
import moment from "moment";
import { CustomerOrderInfo } from "../../../../context";
import MerchantEmployeeLayout from "../../../layout/MerchantEmployeeLayout";
import DialogCashCount from "../../../../utils/merchant-employee/DialogCashCount";
import DialogExpenseCashCount from "./expense";
import CashierSummary from "./CashierSummary";

const MerchantEmployeeCashCount = () => {
  const tableLayout = "";
  const scroll = {};
  const [openModal, setOpenModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [openExpenseDialog, setOpenExpenseDialog] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const { dailyCashFundList, rerunDailyCashFund } =
    useContext(CustomerOrderInfo);

  const tableProps = {
    bordered: false,
    size: "medium",
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "created_at",
      render: (text, record) => (
        <p
          style={{
            fontWeight: "bold",
          }}
        >
          {moment(`${text.replace(" ", "T")}`)
            .utc()
            .format("MMM DD, YYYY")}
        </p>
      ),
    },
    {
      title: "Total Cash Funds",
      dataIndex: "cf_total",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "Total Cash Counts",
      dataIndex: "g_total",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "Total Expense",
      dataIndex: "daily_expense",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "Total Sales",
      dataIndex: "daily_sales",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "Status",
      dataIndex: "",
      render: (text, record) => (
        <p style={{ textAlign: "center" }}>
          {text.g_total === "0.00"
            ? "Waiting"
            : parseFloat(
                parseFloat(text.cf_total) +
                  parseFloat(text.cash) -
                  parseFloat(text.daily_expense)
              ) === parseFloat(text.g_total)
            ? "Exact"
            : parseFloat(text.g_total) >
              parseFloat(
                parseFloat(text.cf_total) +
                  parseFloat(text.cash) -
                  parseFloat(text.daily_expense)
              )
            ? "Over"
            : "Short"}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 110,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 110 }}>
          {text.g_total === "0.00" && (
            <>
              <Tooltip title="Update">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setSelectedData(text);
                    setOpenModal(true);
                  }}
                  icon={<AuditOutlined />}
                  style={{ marginRight: 5 }}
                  // disabled={text.g_total !== "0.00"}
                />
              </Tooltip>
              <Tooltip title="Expense Details">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setSelectedData(text);
                    setOpenExpenseDialog(true);
                  }}
                  icon={<AlertOutlined />}
                  // disabled={text.g_total !== "0.00"}
                />
              </Tooltip>
            </>
          )}

          {text.g_total !== "0.00" && (
            <Tooltip title="Summary">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setSelectedData(text);
                  setInfoModal(true);
                }}
                icon={<AuditOutlined />}
                style={{ marginRight: 5 }}
                // disabled={text.g_total !== "0.00"}
              />
            </Tooltip>
          )}
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  return (
    <MerchantEmployeeLayout>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={
            dailyCashFundList.ready && dailyCashFundList.data.result.length > 0
              ? dailyCashFundList.data.result
              : []
          }
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openModal && (
        <DialogCashCount
          open={openModal}
          close={() => setOpenModal(false)}
          rerun={() => rerunDailyCashFund()}
          selectedData={selectedData}
        />
      )}

      {openExpenseDialog && (
        <DialogExpenseCashCount
          open={openExpenseDialog}
          close={() => setOpenExpenseDialog(false)}
          selectedData={selectedData}
        />
      )}

      {infoModal && (
        <CashierSummary
          open={infoModal}
          close={() => setInfoModal(false)}
          selectedData={selectedData}
        />
      )}
    </MerchantEmployeeLayout>
  );
};

export default MerchantEmployeeCashCount;
